import { useState } from "react";

function HowToTradeFutureAndOptionModule() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "1. Introduction to Futures and Options",
      content: [
        "What are Derivatives?: Understanding the basics of futures and options as derivative instruments.",
        "Key differences between Futures and Options.",
        "Real-life examples of how F&O are used for hedging, speculation, and arbitrage.",
        "Overview of participants in the F&O markets (hedgers, speculators, and arbitrageurs).",
      ],
    },
    {
      title: "2. Basics of Futures Trading",
      content: [
        "What is a Futures Contract?: Understanding contract specifications (lot size, expiry date, tick size).",
        "Mark-to-Market (MTM): How daily settlements work in futures trading.",
        "Margin Requirements: Initial margin, maintenance margin, and leverage in futures.",
        "Understanding Contango and Backwardation in futures pricing.",
        "Real-world examples of trading index futures (e.g., Nifty, Bank Nifty) and stock futures.",
      ],
    },
    {
      title: "3. Basics of Options Trading",
      content: [
        "What is an Option?: Understanding calls and puts, strike prices, and expiration dates.",
        "Intrinsic Value vs. Time Value: Components of an option's premium.",
        "Difference between American vs. European Options.",
        "Introduction to the Options Greeks (Delta, Gamma, Theta, Vega, Rho) and their significance.",
        "Practical examples of trading index options and stock options.",
      ],
    },
    {
      title: "4. Understanding the Options Chain",
      content: [
        "How to read an Options Chain: Strike price, bid-ask spread, volume, and open interest.",
        "Using options chain data to identify support and resistance levels.",
        "Put-Call Ratio (PCR): Gauging market sentiment using PCR analysis.",
        "Identifying unusual options activity for potential trading opportunities.",
      ],
    },
    {
      title: "5. Popular Futures Trading Strategies",
      content: [
        "Long Futures: Profiting from an expected rise in the underlying asset.",
        "Short Futures: Gaining from a decline in the underlying asset.",
        "Hedging with Futures: Protecting your stock portfolio using index futures.",
        "Calendar Spread: Taking advantage of price differences between two expiration dates.",
      ],
    },
    {
      title: "6. Basic Options Trading Strategies",
      content: [
        "Long Call and Long Put: Simple strategies for bullish and bearish market views.",
        "Covered Call: Generating income on existing stock holdings.",
        "Protective Put: Safeguarding stock investments against downside risk.",
        "Cash-Secured Put: Earning premium while waiting to buy stocks at a lower price.",
      ],
    },
    {
      title: "7. Intermediate Strategies for F&O",
      content: [
        "Bull Call Spread and Bear Put Spread: Limited risk, limited reward strategies for directional trades.",
        "Iron Condor and Iron Butterfly: Income strategies for range-bound markets.",
        "Straddle and Strangle: Profiting from high volatility and big market moves.",
        "Ratio Spreads and Backspreads: High-reward strategies for directional and non-directional markets.",
      ],
    },
    {
      title: "8. Volatility Trading with Options",
      content: [
        "Understanding Implied Volatility (IV) and its impact on options pricing.",
        "Strategies for trading in high IV (Volatility Crush) and low IV environments.",
        "VIX (Volatility Index): Using VIX to gauge market fear and greed.",
        "Trading earnings announcements using volatility strategies.",
      ],
    },
    {
      title: "9. Risk Management in F&O Trading",
      content: [
        "Position Sizing: How to calculate the right amount of exposure per trade.",
        "Stop-Loss Orders: Setting stop-loss levels to protect your capital.",
        "Using the Risk-Reward Ratio to evaluate trade setups.",
        "Importance of maintaining a Trading Journal for tracking performance and improving strategies.",
      ],
    },
    {
      title: "10. Live Market Analysis and Execution",
      content: [
        "Technical Analysis: Using charts, trends, and indicators for F&O trading.",
        "Fundamental Analysis: Assessing market conditions and economic data for informed trading.",
        "Step-by-step guide on placing F&O trades using online platforms (e.g., Zerodha, Upstox, Thinkorswim).",
        "Real-life case studies of successful futures and options trades.",
      ],
    },
    {
      title: "11. Taxation and Regulations for F&O Trading",
      content: [
        "Understanding Tax Implications of trading in futures and options.",
        "Overview of SEBI Regulations for F&O traders.",
        "Importance of compliance and ethical trading practices.",
      ],
    },
    {
      title: "12. Common Mistakes and How to Avoid Them",
      content: [
        "Emotional trading: Overcoming greed and fear in the markets.",
        "Overleveraging: Understanding the risks of excessive use of margin.",
        "Averaging Down: Dangers of doubling down on losing trades.",
        "Tips for staying disciplined and sticking to your trading plan.",
      ],
    },
    {
      title: "13. Resources and Tools for F&O Trading",
      content: [
        "Best platforms and tools for F&O trading (Sensibull, Opstra, TradingView).",
        "Using scanners and screeners to find high-probability trades.",
        "Recommended books, courses, and online communities for continuous learning.",
        "How to stay updated with market news, trends, and economic events.",
      ],
    },
  ];

  return (
    <div className="container-fluid">
      <div className="container py-5">
        <h1 className="text-center mb-5">How to Trade in Futures & Options</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div key={index} className="col-12 col-md-5 mb-3">
              {/* Module Header */}
              <div
                className="p-3 d-flex justify-content-between align-items-center"
                style={{
                  background: "#e9ecef",
                  border: "1px solid #ced4da",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: "18px",
                    transform: openModule === index ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s ease",
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Module Content */}
              {openModule === index && (
                <div
                  className="p-3 mt-2"
                  style={{
                    background: "#ffffff",
                    border: "1px solid #ced4da",
                    borderRadius: "5px",
                  }}
                >
                  {module.content.map((item, i) => (
                    <p key={i} style={{ fontSize: "14px", margin: "5px 0" }}>
                      ➤ {item}
                    </p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HowToTradeFutureAndOptionModule;
